import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';

//Create Store with Middleware Thunk to Handle Async Action
const createStoreWithMiddleware = applyMiddleware(thunk) (createStore);

const configureStore = function (initState) {
  const store = createStoreWithMiddleware(rootReducer, initState);
  return store;
}

export default configureStore;



/** WEBPACK FOOTER **
 ** ./src/configureStore.js
 **/